import { render } from "./VabeneDashPage.vue?vue&type=template&id=4e036c78&scoped=true&ts=true"
import script from "./VabeneDashPage.vue?vue&type=script&lang=ts"
export * from "./VabeneDashPage.vue?vue&type=script&lang=ts"

import "./VabeneDashPage.vue?vue&type=style&index=0&id=4e036c78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e036c78"]])

export default __exports__